module.exports = __webpack_public_path__ + "img/sulv_6.05c00481.jpg";